import { render, staticRenderFns } from "./OnboardingView.vue?vue&type=template&id=5a67a191&scoped=true"
import script from "./OnboardingView.vue?vue&type=script&setup=true&lang=js"
export * from "./OnboardingView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OnboardingView.vue?vue&type=style&index=0&id=5a67a191&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a67a191",
  null
  
)

export default component.exports